import { definePreset } from "@primeng/themes";
import Lara from '@primeng/themes/lara';

const shadowOverlay = "var(--app-overlay-shadow)";
const borderOverlaySelected = "var(--app-border-overlay-selected)";

export const appPreset = definePreset(Lara, {
    primitive: {
        borderRadius: {
            none: "0",
            xs: "0",
            sm: "3px",
            md: "3px",
            lg: "4px",
            xl: "6px"
        },
    },
    semantic: {
        primary: {
            50: "#f5f8fb",
            100: "#cedfee",
            200: "#a7c6e0",
            300: "#81add3",
            400: "var(--app-button-primary-bg-hover)",
            500: "var(--app-button-primary-bg)",
            600: "var(--app-text-color-label)",
            700: "#245681",
            800: "#1c4465",
            900: "#14314a",
            950: "#0d1f2e"
        },
        list: {
            option: {
                padding: "0.42rem 0.75rem",
            },
        },
        overlay: {
            select: {
                shadow: shadowOverlay,
            },
            popover: {
                shadow: shadowOverlay,
            },
            modal: {
                shadow: shadowOverlay,
            },
            navigation: {
                shadow: shadowOverlay,
            }
        },
        colorScheme: {
            light: {
                primary: {
                    color: "{primary.500}",
                    contrastColor: "#ffffff",
                    hoverColor: "{primary.400}",
                    activeColor: "{primary.800}"
                },
                formField: {
                    borderColor:"var(--app-input-border-color)",
                    paddingX: "var(--app-input-padding)",
                    paddingY: "var(--app-input-padding)",
                    borderRadius: "var(--p-border-radius-sm)",
                },
                overlay: {
                    select: {
                        borderColor: borderOverlaySelected,
                    },
                    popover: {
                        borderColor: borderOverlaySelected,
                    },
                    modal: {
                        borderColor: borderOverlaySelected,
                    }
                },
                highlight: {
                    background: "{primary.600}",
                    focusBackground: "{primary.700}",
                    color: "#ffffff",
                    focusColor: "#ffffff"
                },
                list: {
                    option: {
                        focusBackground: "{surface.200}",
                    }
                }
            }
        },
    },
    components: {
        button: {
            colorScheme: {
                light: {
                    outlined: {
                        secondary: {
                            borderColor: 'var(--app-button-secondary-border)',
                        }
                    }
                }
            }
        },
        datatable: {
            colorScheme: {
                light: {
                    header: {
                        background: "{content.background}",
                    },
                    headerCell: {
                        background: "{content.background}",
                    }
                }
            }
        },
        paginator: {
            navButton: {
                selectedBackground: "var(--app-text-color-label)",
                selectedColor: "var(--app-bg-color)",
                width: "1.8rem",
                height: "1.8rem",
                borderRadius: "0",
            }
        }
    }
})
